import React from 'react';

export const Loading = () => (
  <div className="loading-shading">
    <span className="glyphicon glyphicon-refresh loading-icon" />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Tables/Loading.js